"use client";

import { useSelector, useDispatch } from "react-redux";
import { Button } from "@/components/ui/button";
import {
  useAddWishlistItemMutation,
  useRemoveWishlistItemMutation,
} from "@/store/wishlist/wishlistApiSlice";
import {
  addWishlistItem,
  removeWishlistItem,
} from "@/store/wishlist/wishlistSlice";
import { generalEcomEvent } from "@/lib/utils";


const WishlistButton = ({ pk, extraClasses, gtagEvent }) => {
  const dispatch = useDispatch();
  const wishlistItems = useSelector((state) => state.wishlist.items);
  const isPresentInWishlist = wishlistItems.includes(pk);

  const [addItem, { isLoading: addLoading }] = useAddWishlistItemMutation();
  const [removeItem, { isLoading: removeLoading }] = useRemoveWishlistItemMutation();

  const handlePress = () => {
    if (addLoading || removeLoading) return;
    if (isPresentInWishlist) {
      dispatch(removeWishlistItem(pk));
      removeItem({ product_id: pk });
    } else {
      dispatch(addWishlistItem(pk));
      addItem({ product_id: pk });
      generalEcomEvent({
        event: "add_to_wishlist",
        other: {
          currency: "INR",
          value: gtagEvent?.price,
        },
        items: [
          {
            item_name: gtagEvent?.name,
            item_id: pk,
            price: gtagEvent?.price,
            item_category: gtagEvent?.category.name,
            item_brand: "ORNAZ",
          },
        ],
      });
    }
  };

  return (
    <Button
      aria-label="add to wishlist"
      className={`
        absolute bg-white top-1.5 right-1.5 
        text-xs rounded-full p-0 
        h-[28px] w-[28px] 
        md:w-[25px] md:h-[25px] 
        xl:w-[30px] xl:h-[30px]
        flex items-center hover:bg-[#fbfbfb]
        ${extraClasses}
      `}
      onClick={handlePress}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="-3 -5 22 22"
        fill={isPresentInWishlist ? "#45d4d5" : "#fff"}
        stroke={isPresentInWishlist ? "transparent" : "gray"}
        className="
          h-[28px] w-[28px] 
          md:w-[25px] md:h-[25px] 
          xl:w-[30px] xl:h-[30px]
          svg-filter
        "
      >
        {" "}
        <path d="
          M4 1c2.21 0 4 1.755 4 3.92C8 2.755 9.79 1 12 1s4 
          1.755 4 3.92c0 3.263-3.234 4.414-7.608 9.608a.513.513 
          0 0 1-.784 0C3.234 9.334 0 8.183 0 4.92 0 2.755 1.79 1 4 1z" 
        />
        {" "}
      </svg>
    </Button>
  );
};

export default WishlistButton;
